export enum EFavoriteAction {
  Added = 'added',
  Removed = 'removed',
}

export interface IFavoriteAction {
  action: EFavoriteAction;
  offerId: number;
}
